import React from "react";
import { useRoutes } from "react-router-dom";
import { useUserContext } from "../../context/user.context";
import { ADMIN_ROUTES, DASHBOARD_ROUTES } from "../RoutesEnum";
import { useUserValidationContext } from "../../context/user-validating.context";

//import "./index.scss";

//Onboarding
const LayoutForSteps = React.lazy(() => import("../../components/Onboarding/LayoutForSteps"));
const Step1 = React.lazy(() => import("../../components/Onboarding/Steps/Step1"));

//Status pages
const StatusPageLayout = React.lazy(() => import("../../components/StatusPages/StatusPageLayout"));
const StatusWaitingForApproval = React.lazy(() => import("../../components/StatusPages/Statuses/StatusWaitingApproval"));
const StatusError = React.lazy(() => import("../../components/StatusPages/Statuses/StatusError"));
const StatusRejected = React.lazy(() => import("../../components/StatusPages/Statuses/StatusRejected"));

// Dashboard
const DashboardLayout = React.lazy(() => import("../../layouts/DashboardLayout"));

//const Wallet = React.lazy(() => import("../../spruha/Cryptocurrencies/Wallet/Wallet"));
const PaymentOverviewPage = React.lazy(() => import("../../pages/Dashboards/PaymentOverviewPage"));
const PerformanceOverviewPage = React.lazy(() => import("../../pages/Dashboards/PerformanceOverviewPage"));
//const Search2 = React.lazy(() => import("../../spruha/AdvanceUI/Search/Search2"));
//const Dashboard = React.lazy(() => import("../../spruha/Dashboard/Dashboard"));
//const Order = React.lazy(() => import("../../spruha/ECommerce/Orders/Orders"));
const TransactionsPage = React.lazy(() => import("../../pages/Transactions/_TransactionsPage"));
const TransactionsServerSidePage = React.lazy(() => import("../../pages/TransactionsServerSide/TransactionsServerSidePage"));
//const Rsmmaps = React.lazy(() => import("../../spruha/Apps/Maps/Rsmmaps/Rsmmaps"));
//const Invoice = React.lazy(() => import("../../spruha/Pages/Invoice/Invoice"));
const ReportPage = React.lazy(() => import("../../pages/Reporter/ReporterPage"));
const DevicesPage = React.lazy(() => import("../../pages/Devices/DevicesPage"));
const DeviceSetup = React.lazy(() => import("../../pages/Devices/DeviceSetup"));
const DeviceDetails = React.lazy(() => import("../../components/Devices/DeviceDetails"));
const DotVosIframe = React.lazy(() => import("../../pages/Devices/DotVosIframe"));
const POSPage = React.lazy(() => import("../../pages/POS/POSPage"));
const POSDetails = React.lazy(() => import("../../components/POS/POSDetails"));
const SetupPOSPage = React.lazy(() => import("../../pages/POS/SetupPOSPage"));
const ActiveCampaigns = React.lazy(() => import("../../pages/Campaign/ActiveCampaigns"));
const CampaignTools = React.lazy(() => import("../../pages/Campaign/CampaignToolPage"));
const CampaignDetails = React.lazy(() => import("../../pages/Campaign/CampaignDetailsPage"));

// coustom pages
const Error404 = React.lazy(() => import("../../pages/ErrorPages/Error-404"));
const Error401 = React.lazy(() => import("../../pages/ErrorPages/Error-401"));

const NotAllowedComponent = <h3>You are not allowed to view this page!</h3>;

export const DashboardRoutesList = (baseUri) => {
  const { roleCanViewDeviceSetup, roleCanManagePOSDevices, roleCanManageCampaigns, roleCanManageMoney } = useUserContext();

  const dashboardRoutesList = [
    {
      path: `${baseUri}${DASHBOARD_ROUTES.ROOT}`,
      element: <DashboardLayout />,
      children: [
        {
          path: `${DASHBOARD_ROUTES.PERFORMANCE_PAGE}`, //DASHBOARD_ROUTES.PERFORMANCE_PAGE,
          element: roleCanManageMoney ? <PerformanceOverviewPage /> : <Error401 />,
        },
        {
          path: `${DASHBOARD_ROUTES.PAYMENT_PAGE}`, //DASHBOARD_ROUTES.PAYMENT_PAGE,
          element: roleCanManageMoney ? <PaymentOverviewPage /> : <Error401 />,
        },
        {
          path: DASHBOARD_ROUTES.DEVICE_PAGE,
          element: roleCanViewDeviceSetup ? <DevicesPage /> : <Error401 />,
        },
        {
          path: `${DASHBOARD_ROUTES.DEVICE_PAGE}/setup`,
          element: roleCanViewDeviceSetup ? <DeviceSetup /> : <Error401 />,
        },
        {
          path: `${DASHBOARD_ROUTES.DEVICE_PAGE}/details/:id`,
          element: roleCanViewDeviceSetup ? <DeviceDetails /> : <Error401 />,
        },
        {
          path: `${DASHBOARD_ROUTES.DEVICE_PAGE}/Management`,
          element: roleCanViewDeviceSetup ? <DotVosIframe /> : <Error401 />,
        },
        {
          path: DASHBOARD_ROUTES.POS_PAGE,
          element: roleCanManagePOSDevices ? <POSPage /> : <Error401 />,
        },
        {
          path: `${DASHBOARD_ROUTES.POS_PAGE}/details/:id`,
          element: roleCanManagePOSDevices ? <POSDetails /> : <Error401 />,
        },
        {
          path: `${DASHBOARD_ROUTES.POS_PAGE}/setup`,
          element: roleCanManagePOSDevices ? <SetupPOSPage /> : <Error401 />,
        },
        /* {
          path: DASHBOARD_ROUTES.TRANSACTION_PAGE,
          element: roleCanManageMoney ? <TransactionsPage /> : <Error401 />,
        }, */
        {
          path: DASHBOARD_ROUTES.TRANSACTION_PAGE_SERVER,
          element: roleCanManageMoney ? <TransactionsServerSidePage /> : <Error401 />,
        },
        {
          path: DASHBOARD_ROUTES.REPORTER_PAGE,
          element: roleCanManageMoney ? <ReportPage /> : <Error401 />,
        },
        {
          path: DASHBOARD_ROUTES.ACTIVECAMPAIGNS_PAGE,
          element: roleCanManageCampaigns ? <ActiveCampaigns /> : <Error401 />,
        },
        {
          path: DASHBOARD_ROUTES.CAMPAIGNTOOLS_PAGE,
          element: roleCanManageCampaigns ? <CampaignTools /> : <Error401 />,
        },
        {
          path: `${DASHBOARD_ROUTES.CAMPAIGNTOOLS_PAGE}/details/:id`,
          element: roleCanManageCampaigns ? <CampaignDetails /> : <Error401 />,
        },
      ],
    },
    // {
    //   path: `${baseUri}${ADMIN_ROUTES.ROOT}`,
    //   element: <Error401 />,
    // },
    // {
    //   path: "*",
    //   element: <Error404 />,
    // },
    {
      path: `${baseUri}/${DASHBOARD_ROUTES.ONBOARDING}`,
      element: <LayoutForSteps />,
      children: [
        {
          path: "steps",
          element: <Step1 />,
        },
      ],
    },
    {
      path: `${baseUri}/${DASHBOARD_ROUTES.ONBOARDING_STATUS}`,
      element: <StatusPageLayout />,
      children: [
        {
          path: `wait`,
          element: <StatusWaitingForApproval />,
        },
        {
          path: `error`,
          element: <StatusError />,
        },
        {
          path: `rejected`,
          element: <StatusRejected />,
        },
      ],
    },
  ];

  //console.log("DashboardRoutes INIT", {dashboardRoutesList, baseUri})
  return dashboardRoutesList;
};

const DashboardRoutes = ({ baseUri = `${process.env.PUBLIC_URL}` }) => {
  //const { location, navigate, match } = useRouteProps("/products/:productId");
  //console.log("ROUTE INFO", { location, navigate, match, baseUri, PUBLIC_URL: process.env.PUBLIC_URL })

  //console.log("DashboardRoutes INIT", DashboardRoutesList(baseUri))
  const routes = useRoutes(DashboardRoutesList(baseUri));
  return routes;
};

export default DashboardRoutes;
